import React, { Fragment } from 'react';
import { shape, arrayOf, string } from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { Heading, Paragraph, Small } from 'components/common';
import Feature from 'components/product/Feature';

import './FeaturesSection.scss';

const Need = ({ textPresent, image }) => (
  <div className="need">
    <img
      className="need-image"
      src={_.get(image, 'url')}
      alt={textPresent}
    />
    <div className="need-name">
      <Small secondary>
        <strong>{textPresent}</strong>
      </Small>
    </div>
  </div>
);

Need.defaultProps = {
  textPresent: null,
  image: {
    url: null,
  },
};

Need.propTypes = {
  textPresent: string,
  image: shape({
    url: string,
  }),
};

const renderTitles = (titles, header) => (
  titles.map((title, index) => (
    // eslint-disable-next-line
    <Heading key={index} as={(header === 'h3') ? 'h3' : 'h2'}>
      {title}
    </Heading>
  ))
);

const FeaturesSection = ({
  titles,
  features: { pros, cons },
  needCategories = [],
  labels = {},
}) => (
  <div className="features-section">
    <div className="container-wrapper">
      <div className="features-section-title-wrapper">
        <div className="row-wrapper">
          <div className="features-section-title">
            {renderTitles(titles)}
          </div>
        </div>
      </div>
      <div className="features-section-mobile-title">
        {renderTitles(titles, 'h3')}
      </div>
      {needCategories && needCategories.length > 0 && (
        <Fragment>
          <div className="needs-wrapper">
            <div className="row-wrapper">
              <div className="needs">
                {needCategories.map(need => (
                  <div className="need-wrapper" key={need.title}>
                    <Need {...need} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mobile-needs">
            <div className="row-wrapper">
              {needCategories.map(need => (
                <div className="need-wrapper" key={need.title}>
                  <Need {...need} />
                </div>
              ))}
            </div>
          </div>
        </Fragment>
      )}
      {((pros && pros.length > 0) || (cons && cons.length > 0)) && (
        <div className="row-wrapper">
          <div className="features-wrapper">
            <div
              className={classNames({
                'row-wrapper': true,
                // set full width if only one of two columns exists
                'full-width-child': !(pros && pros.length > 0 && cons && cons.length > 0),
              })}
            >
              {pros && pros.length > 0 && (
                <div className="pros">
                  <Paragraph>
                    <strong>
                      {labels.subHeadingGreatFor}
                    </strong>
                  </Paragraph>
                  {pros.map(pro => (
                    <Feature
                      pro
                      key={pro}
                      htmlString={pro}
                    />
                  ))}
                </div>
              )}
              {cons && cons.length > 0 && (
                <div className="cons">
                  <Paragraph>
                    <strong>
                      {labels.subHeadingNeedToKnow}
                    </strong>
                  </Paragraph>
                  {cons.map(con => (
                    <Feature
                      con
                      key={con}
                      htmlString={con}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);

FeaturesSection.defaultProps = {
  titles: [],
  features: {},
  needCategories: [],
  labels: {},
};

FeaturesSection.propTypes = {
  titles: arrayOf(string),
  features: shape({
    pros: arrayOf(string).isRequired,
    cons: arrayOf(string).isRequired,
  }),
  needCategories: arrayOf(shape({
    name: string,
    image: shape({
      url: string,
    }),
  })),
  labels: shape({
    subHeadingGreatFor: string,
    subHeadingNeedToKnow: string,
  }),
};

export default FeaturesSection;
